









import { Component, Vue } from 'vue-property-decorator';
import { MenuModuleMapper } from '@/store/modules/menu';

import SideBarMenuItem from './sideBarMenuItem.vue';

const Mappers = Vue.extend({
  computed: MenuModuleMapper.mapGetters(['expandedLvl', 'itemsList', 'menuIsLoaded']),
});

@Component({
  props: {
    title: String,
    type: String,
    innerWidth: Number,
  },
  components: {
    SideBarMenuItem,
  },
})
export default class SideBarMenuComponent extends Mappers {
  get menu() {
    return this.itemsList('root', this.$props.type);
  }
}
